import { createAsyncThunk } from '@reduxjs/toolkit'

interface IThunkResult {}
export const fetchContactUsThunk = createAsyncThunk<IThunkResult>('fetchContactUsThunk', async (_, thunkAPI) => {
  return {}
})
